$('document').ready(function () {

    if (document.getElementById('employerForm')) {
        $('select[multiple="multiple"]').select2();


        if (document.getElementById('isEdit')) {
            // var focus = 0;
            // var data;

            function onchangeEl(el) {
                // focus++;
                // if (focus > 2) {
                var isValid = el.siblings("small.help-block").attr("data-fv-result");
                if (isValid == "VALID" || !isValid) {

                    data = {
                        name: el.attr('name'),
                        value: el.val(),
                        is_part_edit: true
                    };
                    $.when(postRequest(data, "/Register/Employer/Set"))
                        .done(function (answer) {
                            }
                        );
                }
                // }
            }

            $("input").change(function () {
                onchangeEl($(this));
            });
            $("select").change(function () {
                onchangeEl($(this));
            });
            $("textarea").change(function () {
                onchangeEl($(this));
            });
        }

        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

    }
});